export const InstancesInternalFormsActionTypes = {
  API_RESPONSE_SUCCESS: '@@instances-internal-forms/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@instances-internal-forms/API_RESPONSE_ERROR',

  GET_INSTANCE_INTERNAL_FORM: '@@instances-internal-forms/GET_INSTANCE_INTERNAL_FORM',
  LIST_INSTANCES_INTERNAL_FORMS: '@@instances-internal-forms/LIST_INSTANCES_INTERNAL_FORMS',
  ADD_INSTANCE_INTERNAL_FORM: '@@instances-internal-forms/ADD_INSTANCE_INTERNAL_FORM',
  UPDATE_INSTANCE_INTERNAL_FORM: '@@instances-internal-forms/UPDATE_INSTANCE_INTERNAL_FORM',
  DELETE_INSTANCE_INTERNAL_FORM: '@@instances-internal-forms/DELETE_INSTANCE_INTERNAL_FORM',

  RESET: '@@instances-internal-forms/RESET'
}
